import { Helmet } from "react-helmet-async";

export const SITE_URL = "https://devtechpro.fr";
const DEFAULT_TITLE = "Dev-Tech - Solutions Digitales";
const DEFAULT_DESCRIPTION =
  "Dev-Tech propose des solutions digitales innovantes : développement web, applications React, marketing et accompagnement technique pour accélérer votre croissance.";
const DEFAULT_IMAGE = `${SITE_URL}/logo-og.png`;

export default function SeoMeta({
  title,
  description,
  canonical,
  openGraph = {},
  twitter = {},
  jsonLd
}) {
  const resolvedTitle = title ? `${title} | Dev-Tech` : DEFAULT_TITLE;
  const resolvedDescription = description || DEFAULT_DESCRIPTION;
  const canonicalUrl = canonical || SITE_URL;

  const ogImage = openGraph.image || DEFAULT_IMAGE;
  const ogUrl = openGraph.url || canonicalUrl;
  const ogTitle = openGraph.title || resolvedTitle;
  const ogDescription = openGraph.description || resolvedDescription;
  const twitterImage = twitter.image || ogImage;
  const twitterTitle = twitter.title || resolvedTitle;
  const twitterDescription = twitter.description || resolvedDescription;

  return (
    <Helmet>
      <title>{resolvedTitle}</title>
      <meta name="description" content={resolvedDescription} />
      <link rel="canonical" href={canonicalUrl} />

      {/* Open Graph */}
      <meta property="og:type" content={openGraph.type || "website"} />
      <meta property="og:url" content={ogUrl} />
      <meta property="og:title" content={ogTitle} />
      <meta property="og:description" content={ogDescription} />
      <meta property="og:image" content={ogImage} />

      {/* Twitter */}
      <meta name="twitter:card" content={twitter.card || "summary_large_image"} />
      <meta name="twitter:title" content={twitterTitle} />
      <meta name="twitter:description" content={twitterDescription} />
      <meta name="twitter:image" content={twitterImage} />

      {jsonLd && (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      )}
    </Helmet>
  );
}